import App from "@frog/source/models/App.js"
import Audio from "@frog/source/utility/Audio.js"
import Navigation from "@frog/source/models/Navigation.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import Travel from "@frog/source/data/games/ember/travel.js"

export default {
    "slug": "ember",
    "title": "Ember",
    "firstChapterKey": "1",
    "player": require("./player.js").default,
    "chapters": {
        "1": require("./1").default,
        "2": require("./2").default,
        "3": require("./3").default,
    },
    "configuration": {
        // "darkness": true,
        "darkness": "none",
        "squigglevision": false,
    },
    "credits": [
        "Andrew Goodenough",
        "Anna Arkhipova",
        "Doc McPherson",
    ],
    "overworld": {
        "image": require("./overworld.png"),
        "locations": {
            "z1-1": {
                "key": "z1-1",
                "chapterKey": "1",
                "position": {"x": 1, "y": 1},
                "isDisplayed": true,
                "isReachable": true,
                "text": "z1-1",
            },
            "z1-2": {
                "key": "z1-2",
                "chapterKey": "z1-2",
                "position": {"x": 1, "y": 2},
                "isDisplayed": true,
                "text": "z1-2",
            },
            "z1-3": {
                "key": "z1-3",
                "chapterKey": "z1-3",
                "position": {"x": 1, "y": 3},
                "isDisplayed": true,
                "text": "z1-3",
            },
            "z1-4": {
                "key": "z1-4",
                "chapterKey": "z1-4",
                "position": {"x": 1, "y": 4},
                "isDisplayed": true,
                "text": "z1-4",
            },
            "z2-1": {
                "key": "z2-1",
                "chapterKey": "z2-1",
                "position": {"x": 4, "y": 1},
                "isDisplayed": true,
                "text": "z2-1",
            },
            "z2-2": {
                "key": "z2-2",
                "chapterKey": "z2-2",
                "position": {"x": 4, "y": 2},
                "isDisplayed": true,
                "text": "z2-2",
            },
            "z2-3": {
                "key": "z2-3",
                "chapterKey": "z2-3",
                "position": {"x": 4, "y": 3},
                "isDisplayed": true,
                "text": "z2-3",
            },
            "z2-4": {
                "key": "z2-4",
                "chapterKey": "z2-4",
                "position": {"x": 4, "y": 4},
                "isDisplayed": true,
                "text": "z2-4",
            },
            "z3-1": {
                "key": "z3-1",
                "chapterKey": "z3-1",
                "position": {"x": 7, "y": 1},
                "isDisplayed": true,
                "text": "z3-1",
            },
            "z3-2": {
                "key": "z3-2",
                "chapterKey": "z3-2",
                "position": {"x": 7, "y": 2},
                "isDisplayed": true,
                "text": "z3-2",
            },
            "z3-3": {
                "key": "z3-3",
                "chapterKey": "z3-3",
                "position": {"x": 7, "y": 3},
                "isDisplayed": true,
                "text": "z3-3",
            },
            "z3-4": {
                "key": "z3-4",
                "chapterKey": "z3-4",
                "position": {"x": 7, "y": 4},
                "isDisplayed": true,
                "text": "z3-4",
            },
            "z4-1": {
                "key": "z4-1",
                "chapterKey": "z4-1",
                "position": {"x": 10, "y": 1},
                "isDisplayed": true,
                "text": "z4-1",
            },
            "z4-2": {
                "key": "z4-2",
                "chapterKey": "z4-2",
                "position": {"x": 10, "y": 2},
                "isDisplayed": true,
                "text": "z4-2",
            },
            "z4-3": {
                "key": "z4-3",
                "chapterKey": "z4-3",
                "position": {"x": 10, "y": 3},
                "isDisplayed": true,
                "text": "z4-3",
            },
            "z4-4": {
                "key": "z4-4",
                "chapterKey": "z4-4",
                "position": {"x": 10, "y": 4},
                "isDisplayed": true,
                "text": "z4-4",
            },
        }
    },
    "openingEvents": function() {
        return [
            {"func": () => Navigation.go("/games/ember/overworld")},
            "The journey begins.",
            PlotSteps.TransitionStart(),
            {"func": () => Navigation.go("/games/ember/chapters/1")},
            PlotSteps.TransitionEnd(),
        ]
    },
    "audio": {
        "Ember:Music:Combat": {
            "volume": 0.32,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/borrowed/pyre-pathtoglory.mp3"))
        },
        "Ember:Music:Wander": {
            "volume": 0.32,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/borrowed/pyre-willofthescribes.mp3"))
        },
        "Ember:Music:Sad": {
            "volume": 0.32,
            "loop": false,
            "label": "music",
            "kill": {"label": "music"},
            "audio": new Audio(require("@frog/source/assets/audio/borrowed/httyd - forbidden friendship.mp3"))
        },
        "Dialogue:Blip": {
            "volume": 0.3,
            "type": "once:randomly",
            "audio": [
                new Audio(require("@frog/source/assets/audio/horror-tactics/select-move1.mp3")),
                new Audio(require("@frog/source/assets/audio/horror-tactics/select-move2.mp3")),
            ],
        },
        "Unit:Death:Knell": {
            "volume": 0.5,
            "audio": new Audio(require("@frog/source/assets/audio/horror-tactics/death-knell.mp3"))
        },
    }
}
